import React, { FC, useEffect, useRef } from 'react'
import './service-outage-modal.css'

// TYPES
import type { FailedResponse } from '@apis'

// UTILITIES
import { flatten } from '@utils/string-helper'
import Button from '@components/atoms/button'


interface Props extends React.HTMLAttributes<HTMLDialogElement> {
    state: [boolean, React.Dispatch<React.SetStateAction<boolean>>]
    error?: Partial<FailedResponse>
}

const ServiceOutageModal: FC<Props> = (props) => {
    const { className: classProp, state, error, ...divProps } = props
    const className = flatten('service-outage-modal', classProp)
    const ref = useRef<HTMLDialogElement>(null)
    const [isOpen, setIsOpen] = state

    useEffect(() => {
        if (ref.current) {
            if (isOpen) ref.current.showModal();
            else ref.current.close()
        }
    }, [isOpen])

    return (
        <dialog ref={ref} className={className} onClose={() => { setIsOpen(false) }} {...divProps}>
            <div>
                <form className="flex flex-col items-stretch" method="dialog">
                    <h2>Service Outage</h2>
                    <p>{error?.message ? error.message : 'We\'re experiencing a service disruption with a third-party partner. We apologize for the inconvenience and are working toward a resolution.'}</p>
                    <Button type="submit">Okay</Button>
                </form>
            </div>
        </dialog>
    )
}

export default ServiceOutageModal